import { Trans } from '@lingui/react/macro';
import { ArrowRight } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { ButtonClicked } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button, CardContent, FlexDivider } from 'src/components';
import { PromotionCheckoutLink } from 'src/components/PromotionCheckoutLink';
import { SUPPORT_URL } from 'src/utils/urls/supportUrls';
import { URLS } from 'src/utils/urls/urls';

export const NoSubscriptionPairedDeviceCard = () => {
  return (
    <CardContent dataCy="subscription-no-plan-paired-device">
      <div className="flex flex-col gap-32 lm:flex-row">
        <div className="flex flex-1 flex-col justify-between gap-24">
          <Typography variant="body-sm" className="my-0">
            <Trans>If your reMarkable was purchased </Trans>
            <Typography variant="body-sm" fontWeight="bold" as="strong">
              <Trans>after October 12, 2021</Trans>
            </Typography>{' '}
            <Trans>you can buy a new Connect subscription right here:</Trans>
          </Typography>

          <div className="flex flex-wrap items-center gap-24">
            <Button
              data-cy="buy-connect"
              as="a"
              variant="primary"
              onClick={(e) => {
                tracker.trackEvent(
                  new ButtonClicked({
                    component_location:
                      ComponentLocations.CONNECT.NO_ACTIVE_SUBSCRIPTION_CARD,
                    text: e.currentTarget.innerText,
                    link_source: URLS.STORE_CONNECT_LANDING,
                  })
                );
              }}
              to={URLS.STORE_CONNECT_LANDING}
            >
              <span>
                <Trans>Get Connect</Trans>
              </span>
              <ArrowRight />
            </Button>
            <PromotionCheckoutLink
              componentLocation={ComponentLocations.SUBSCRIPTION.PLAN_PAGE}
            />
          </div>
        </div>

        <FlexDivider />

        <div className="flex flex-1 flex-col justify-between gap-24">
          <Typography variant="body-sm" className="my-0">
            <Trans>
              If your device was purchased{' '}
              <Typography variant="body-sm" fontWeight="bold" as="strong">
                before October 12, 2021
              </Typography>{' '}
              then you&apos;re entitled to full free access to Connect:
            </Trans>
          </Typography>

          <Button
            variant="secondary"
            as="a"
            target="_blank"
            to={SUPPORT_URL.ARTICLES.ABOUT_CONNECT_SUBSCRIPTION}
            onClick={(e) => {
              tracker.trackEvent(
                new ButtonClicked({
                  component_location:
                    ComponentLocations.CONNECT.NO_ACTIVE_SUBSCRIPTION_CARD,
                  text: e.currentTarget.innerText,
                  link_source: URLS.STORE_CONNECT_LANDING,
                })
              );
            }}
          >
            <span>
              <Trans>Claim free access</Trans>
            </span>
          </Button>
        </div>
      </div>
    </CardContent>
  );
};
